module.exports = __webpack_public_path__ + "static/media/Velasca - Sand - Bordeaux_White.fb590142.jpg";